import { ReactNode } from 'react';
import { Typography } from 'antd';

const { Title } = Typography;
const DrawerSectionEcho = ({
  title,
  children,
  'aria-label': ariaLabel,
}: {
  title: string;
  children: ReactNode;
  'aria-label'?: string;
}) => (
  <div className="mt-6">
    <Title level={4} aria-label={ariaLabel}>
      {title}
    </Title>
    <section className="flex flex-col rounded-lg p-6 gap-6 bg-[#F8F8FC]">{children}</section>
  </div>
);

export default DrawerSectionEcho;
